import { Component } from '@angular/core';

import { pedidoCancelado } from '../../pedido-status';

@Component({
    selector: 'sgt-pedido-status-badge-cancelado',
    templateUrl: './pedido-status-badge-cancelado.component.html',
    styleUrls: ['./pedido-status-badge-cancelado.component.less']
})
export class PedidoStatusBadgeCanceladoComponent {
    status = pedidoCancelado;
}
